import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c7deb5c4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "section"
};
const _hoisted_2 = {
  class: "notice-box"
};
const _hoisted_3 = {
  class: "link-list"
};
const _hoisted_4 = {
  class: "text"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shouqi1"
}, null, -1));

const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "news-list"
};
const _hoisted_9 = {
  key: 0,
  class: "notice-list",
  style: {}
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["title"];
const _hoisted_12 = {
  key: 0,
  class: "date"
};
const _hoisted_13 = {
  key: 1,
  class: "no-data"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CardHeader = _resolveComponent("CardHeader");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", {
    class: "news-container",
    style: _normalizeStyle({
      width: $props.contentWidth,
      'padding-right': $props.isPadding == 1 ? '30px' : 0
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_CardHeader, {
    link: `/notice.html?name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, {
    left: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($props.menu.module_name), 1)])]),
    right: _withCtx(() => [_hoisted_5, _hoisted_6]),
    _: 1
  }, 8, ["link"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "notice-item",
      key: index,
      onClick: $event => $options.goNewsDetail(item)
    }, [_createElementVNode("div", {
      class: "title text-overflow",
      title: item.news_name
    }, _toDisplayString(item.news_name), 9, _hoisted_11), !$props.isPadding ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$utils.formatDate(item.publish_time, 'YYYY-MM-DD')), 1)) : _createCommentVNode("", true)], 8, _hoisted_10);
  }), 128))])) : _createCommentVNode("", true), $data.newsList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_Empty, {
    type: "message"
  })])) : _createCommentVNode("", true)])])])])], 4);
}